import { MainTemplate } from "@/components/templates";

export const MainPage = () => {
  return <MainTemplate />;
};
